import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { setSeo, ogImageUrl } from "@/lib/seo";
import PublicLayout from "@/components/public/PublicLayout";
import BlockRenderer from "@/components/public/BlockRenderer";

export default function PublicPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(undefined);

  useEffect(() => {
    setPage(undefined);
    api.get(`/public/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setPage(null));
  }, [slug]);

  useEffect(() => {
    if (page) setSeo({
      title: page.seo?.meta_title || page.title,
      description: page.seo?.meta_description || "",
      image: ogImageUrl(),
    });
  }, [page]);

  return (
    <PublicLayout>
      {page === undefined ? (
        <div className="min-h-screen flex items-center justify-center">
          <div className="w-8 h-8 border-2 border-black/20 border-t-black rounded-full animate-spin" />
        </div>
      ) : page ? (
        <div className="pt-16"><BlockRenderer blocks={page.blocks} /></div>
      ) : (
        <div className="min-h-[80vh] flex items-center justify-center px-6 text-center">
          <div>
            <h1 className="font-display text-6xl font-bold mb-4">404</h1>
            <p className="font-body text-[#555] mb-8">This page doesn’t exist or hasn’t been published yet.</p>
            <Link to="/" className="underline font-body">Back home</Link>
          </div>
        </div>
      )}
    </PublicLayout>
  );
}
